import { useEffect, useCallback } from 'react';

const useUserActivity = () => {
  const updateLastActivity = useCallback(() => {
    localStorage.setItem('lastActivity', Date.now().toString());
  }, []);

  useEffect(() => {
    // Eventos que indican actividad del usuario
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    
    // Agregar listeners para detectar actividad
    events.forEach(event => {
      document.addEventListener(event, updateLastActivity, true);
    });

    // Limpiar listeners cuando el componente se desmonte
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, updateLastActivity, true);
      });
    };
  }, [updateLastActivity]);

  const isUserActive = useCallback(() => {
    const lastActivity = localStorage.getItem('lastActivity');
    if (!lastActivity) return true; // Si no hay registro, asumir activo
    
    const now = Date.now();
    const tenMinutesAgo = now - (10 * 60 * 1000);
    return parseInt(lastActivity) > tenMinutesAgo;
  }, []);

  return { updateLastActivity, isUserActive };
};

export default useUserActivity;
